export const initMasterClassRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/masterclass",
          name: "masterclass",
          component: () => import("@/pages/manage/masterclasses/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors, config.roles.eventManagers],
          },
        },
        {
          path: "/manage/masterclass/:id",
          name: "masterclass-id",
          component: () => import("@/pages/manage/masterclasses/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors, config.roles.eventManagers],
          },
        },
      ];
